import * as React from 'react';
import { SVGProps } from '../../types';

export const IconTrueFalseSvg = ({ title, titleId, ...props }: SVGProps) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    focusable="false"
    fill="none"
    stroke="currentColor"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path fillRule="evenodd" clipRule="evenodd" d="M10 13L15 8L10 13Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path fillRule="evenodd" clipRule="evenodd" d="M10 8L15 13L10 8Z"   strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 7.85715L5 10L9 5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
